import classNames from "classnames"
import classes from "./CustomCard.module.css"
import React from "react"
import Stroke from "../../atoms/Stroke"
import Typography from "../../atoms/Typography"

export interface CustomCardProps {
  head?: React.ReactNode
  headClassName?: string
  children?: React.ReactNode
  contentClassName?: string
  className?: string
  separator?: boolean
}

const CustomCard = ({
  head,
  headClassName,
  contentClassName,
  children,
  className,
  separator,
}: CustomCardProps) => {
  return (
    <section className={classNames(className, classes.card)}>
      {head && (
        <>
          <Typography
            textClassName={classNames(classes.head, headClassName)}
            variant="h5"
          >
            {head}
          </Typography>
          {separator && <Stroke className={classes.cardSeparator} />}
        </>
      )}
      {children && (
        <div className={classNames(classes.content, contentClassName)}>
          {children}
        </div>
      )}
    </section>
  )
}

export default CustomCard
